(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["theodore-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('theodore-share')) {
    class TheodoreShare extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.td-share__btn');
        this.menu = this.querySelector('.td-share__menu');
        this.toast = this.querySelector('.td-share__toast');
        this.button?.addEventListener('click', () => this.share());
        this.querySelector('[data-copy]')?.addEventListener('click', () => this.copy());
        this._outside = (e) => { if (!this.contains(e.target)) this.close(); };
        this._escape = (e) => { if (e.key === 'Escape') this.close(); };
      }
      disconnectedCallback() { this.close(); }
      async share() {
        const data = { title: this.dataset.title, text: this.dataset.text, url: this.dataset.url };
        if (navigator.share && (!navigator.canShare || navigator.canShare(data))) {
          try { await navigator.share(data); return; } catch (e) { if (e && e.name === 'AbortError') return; }
        }
        if (this.menu.hidden) this.open(); else this.close();
      }
      open() {
        this.menu.hidden = false;
        this.button.setAttribute('aria-expanded', 'true');
        document.addEventListener('click', this._outside, true);
        document.addEventListener('keydown', this._escape);
      }
      close() {
        if (!this.menu || this.menu.hidden) return;
        this.menu.hidden = true;
        this.button.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this._outside, true);
        document.removeEventListener('keydown', this._escape);
      }
      async copy() {
        try { await navigator.clipboard.writeText(this.dataset.url); this.say('Link copied'); }
        catch (e) { this.say(this.dataset.url); }
        this.close();
      }
      say(text) {
        if (!this.toast) return;
        this.toast.textContent = text;
        clearTimeout(this._t);
        this._t = setTimeout(() => { this.toast.textContent = ''; }, 2500);
      }
    }
    customElements.define('theodore-share', TheodoreShare);
  }
  } catch(e) { console.error(e); }
})();

})();
